import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SettingsSection from './settings-section';

const PasswordSettingsSection = () => {
  const { t } = useTranslation();

  return (
    <SettingsSection title={t('password-settings-title')}>
      <p>{t('password-settings-description')}</p>
      <div className="actions">
        <Link to="/password-recovery" className="btn">
          {t('common-change-password')}
        </Link>
      </div>
    </SettingsSection>
  );
};

export default PasswordSettingsSection;
